export { DidCommMessageSendRequest } from './DidCommMessageSendRequest';
export { DidcommMessageSearchRequest } from './DidcommMessageSearchRequest';
export { DidcommMessageUpdateAnnotationsRequest } from './DidcommMessageUpdateAnnotationsRequest';
export { DidcommMessageUpdateLabelsRequest } from './DidcommMessageUpdateLabelsRequest';
